define.alias("shared/components/shared/profile-categorization/icons", "calendar/components/shared/profile-categorization/icons");